import Image from 'next/image';
import React from 'react';

import CTAButton from '~/shared/components/cta-button';
import Link from '~/shared/components/link';
import type { ItemDataType } from '~/shared/types/general-type';
import type { I18nextOptionsType } from '~/shared/types/i18n-type';

import './blog-banner-tile-item.scss';

import blogCategoryBg from '~/assets/blog-category-bg.webp';

type ExtendedTileItemPropsType = {
  data: ItemDataType;
  pageToGo: string;
  isContainItemImage: boolean;
  pageTagsToGo?: string;
  t: (key: string, options: I18nextOptionsType) => string;
};

const BlogBannerTileItem = ({
  data,
  lng,
  pageTagsToGo,
  isContainItemImage = false,
  pageToGo,
}: ExtendedTileItemPropsType) => {
  return (
    <article itemProp="blogPosts" itemScope itemType="http://schema.org/BlogPosting" className="blog-banner-tile-item">
      <Image
        loading="eager"
        alt={data?.title}
        title={data?.title}
        src={blogCategoryBg?.src}
        width={652}
        height={520}
        style={{
          width: 'auto',
          height: 'auto',
        }}
        className="blog-banner-tile-item__background"
      />
      <div className="blog-banner-tile-item__content-wrapper">
        <div className="blog-banner-tile-item__content">
          <h4 itemProp="headline" className="blog-banner-tile-item__title">
            <Link itemProp="url" href={data?.link}>
              {data?.title}
            </Link>
          </h4>
          <div
            itemProp="description"
            className="blog-banner-tile-item__text"
            suppressHydrationWarning
            dangerouslySetInnerHTML={{ __html: data?.description }}
          />
          <div className="blog-banner-tile-item__cta-button">
            <CTAButton link={data?.link} whiteMode content={data?.linkText} />
          </div>
        </div>
      </div>
    </article>
  );
};

export default BlogBannerTileItem;
